import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

// planAsAtTomorrow is used to check if there is a midnight plan change pending
const planAsAtTomorrowSlice = createSlice({
  name: "planChangeTomorrow",
  initialState: {
    planId: undefined,
  },
  reducers: {
    setPlanAsAtTomorrow: (state, action: PayloadAction<{ planId: string }>) => {
      const { planId } = action.payload;

      state.planId = planId;
    },
  },
});

export const { setPlanAsAtTomorrow } = planAsAtTomorrowSlice.actions;
export const planAsAtTomorrowSliceReducer = planAsAtTomorrowSlice.reducer;
